export const pageIdLogObject = {
    pageMatch: {
        path: null,
    },
    withTab: true,
    lastTab: null,
};